import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SafeResourceUrlPipe } from '@iris/common/modules/pipes-common/pipes';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { SkModalBase, SkModalContentComponent, StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'imprint-info-modal',
  imports: [
    SkModalContentComponent,
    TranslateModule,
    SafeResourceUrlPipe,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
  templateUrl: './imprint-info-modal.component.html',
  styleUrl: './imprint-info-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImprintInfoModalComponent extends SkModalBase<ImprintInfoModalComponent, void> {
  private readonly translate = inject(TranslateService);
  readonly userLocale = this.translate.currentLang === 'de' ? 'de' : 'en';
  readonly path = 'assets/legal/imprint-' + this.userLocale + '.html';
}
